import React from 'react';
import { StyledFooter } from '@minerva-analytics/pantheon';
import { BLACK } from '../../theme';
import { FooterContainer } from './Footer.styles';
import { FACEBOOK_LINK, INSTAGRAM_LINK, SHOP_LINK } from '../../constants';

export const Footer = () => {
  const SocialButtons = {
    facebook: FACEBOOK_LINK,
    instagram: INSTAGRAM_LINK,
    shop: SHOP_LINK,
  };

  const links = [
    { to: `/privacy`, title: `Privacy Policy` },
    { to: `/terms`, title: `Terms of Service` },
    { to: `/cookie`, title: `Cookie Policy` },
    { to: `/ccpa`, title: `CA Privacy Policy` },
  ];

  return (
    <FooterContainer>
      <StyledFooter
        productName={`Starguide`}
        productLogo={`https://storage.googleapis.com/starlies/starlies_mobile_logo.png`}
        textColor={BLACK}
        backgroundColor={`#E8F7F8`}
        socialButtons={SocialButtons}
        links={links}
      />
    </FooterContainer>
  );
};

export default Footer;
